// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Ik-z","tupacHeader":"Jk-z","tupacHeader2":"Kk-z","tupacMenu":"Lk-z","tupacMenu2":"Mk-z","tupacMain":"Nk-z","tupacMain2":"Ok-z"};